<template>
  <el-tabs v-model="activeName" class="board-menu" @tab-click="dealClick">
    <el-tab-pane v-for="(menu, index) in menuList" :key="index" :name="menu.name">
      <template v-slot:label>
        <div class="nav-label" @click="select(menu, index)">{{ menu.name }}</div>
      </template>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "board-menu",
  props: {
    menuList: Array,
    active: String
  },
  data() {
    return {
      activeName: ""
    }
  },
  created() {
    this.activeName = this._.cloneDeep(this.active)
  },
  methods: {
    select(menu, index) {
      this.$emit("select", menu)
    },
    dealClick(tab, event) {
      this.select(this.menuList[tab.index])
    }
  }
}
</script>

<style lang="scss" scoped>
.board-menu {
  width: 100%;
  color: $color-font-first;
  ::v-deep {
    .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }
    .el-tabs__item {
      padding: 0 10px;
      font-weight: unset;
      color: #606266;
      &.is-active {
        color: #409eff;
        font-weight: 500;
      }
    }
  }
}
</style>
